import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const Contact = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Add form submission logic here
  };

  return (
    <>
      <SEO
        title="Contact Us | Mobile Detail Co."
        description="Contact Mobile Detail Co for appointments, questions, or quotes. We're here to help with all your car detailing needs in the Twin Cities area."
        url="https://mobiledetailco.com/contact"
      />
      <div className="min-h-screen bg-gradient-to-b from-white to-primary-light pt-24">
        <section className="py-20">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-6xl font-bold text-primary text-center mb-8">
              Contact Us
            </h1>
            <div className="max-w-4xl mx-auto mb-12 text-center">
              <p className="text-xl text-gray-600 mb-4">
                We're here to help with all your car detailing needs in the Twin Cities area.
              </p>
              <div className="space-y-2">
                <p className="text-lg text-gray-700">
                  <strong>Phone:</strong>{" "}
                  <a href="tel:6512869930" className="text-primary hover:underline">
                    (651) 286-9930
                  </a>
                </p>
                <p className="text-lg text-gray-700">
                  <strong>Email:</strong>{" "}
                  <a href="mailto:support@mobiledetailco.com" className="text-primary hover:underline">
                    support@mobiledetailco.com
                  </a>
                </p>
              </div>
            </div>
            <div className="max-w-2xl mx-auto">
              <Card>
                <CardContent className="p-6">
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Name
                      </label>
                      <Input placeholder="Your name" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                      </label>
                      <Input type="email" placeholder="Your email" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Phone
                      </label>
                      <Input type="tel" placeholder="Your phone number" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Message
                      </label>
                      <Textarea placeholder="How can we help you?" />
                    </div>
                    <Button
                      type="submit"
                      className="w-full bg-primary hover:bg-primary/90"
                    >
                      Send Message
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;
